<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" loader="dots"></loading>
    <div class="fixed-list-item">
      <eva-icon fill="#000" name="refresh-outline" @click="reload" />
    </div>
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">面談日期</label>
              <el-date-picker
                style="width: 100%"
                v-model="search.RangeDate"
                value-format="yyyy-MM-dd"
                type="daterange"
                start-placeholder="開始日期"
                end-placeholder="結束日期"
              >
                >
              </el-date-picker>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">時段</label>
              <el-select
                style="display: block"
                v-model="search.TimePeriod"
                placeholder="請選擇"
                clearable
              >
                <el-option
                  :key="option.Value"
                  :label="option.Text"
                  v-for="option in timePeriodOptions"
                  :value="option.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">應徵職務</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.ManpowerDemandName"
              />
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">招募窗口</label>
              <el-select
                style="width: 100%"
                v-model="search.ContactPersonGuid"
                multiple
                filterable
                placeholder="請選擇"
                clearable
              >
                <el-option
                  v-for="item in contactList"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">姓名</label>
              <input
                type="text"
                id="search-name"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.Name"
              />
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">是否異常</label>
              <el-select
                style="display: block"
                v-model="search.AnyWrong"
                placeholder="請選擇"
                clearable
              >
                <el-option label="全部" :value="null"> </el-option>
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">是否回覆</label>
              <el-select
                style="display: block"
                v-model="search.Replied"
                placeholder="請選擇"
                clearable
              >
                <el-option label="全部" :value="null"> </el-option>
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <button
              @click="getData()"
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-right: 5px"
            >
              {{ i18n("Buttons.Search") }}
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              style="margin-top: 30px; margin-right: 5px"
              @click="
                search = {
                  RangeDate: search.RangeDate,
                }
              "
            >
              清除
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right mb-2">
      <el-button type="primary" size="small" @click="exportExcel"
        >匯出</el-button
      >
    </div>

    <div class="yahome-table-wrap">
      <el-table :data="tableData.FeedBacks" style="width: 100%" height="700px">
        <el-table-column
          label="面試日期"
          :width="
            tableData.FeedBacks &&
            tableData.FeedBacks.length > 0 &&
            tableData.DynamicQuestionHeader.length > 0
              ? 120
              : null
          "
          prop="InvitationTime"
          :formatter="dateFormatter"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="Name"
          label="姓名"
          :width="
            tableData.FeedBacks &&
            tableData.FeedBacks.length > 0 &&
            tableData.DynamicQuestionHeader.length > 0
              ? 120
              : null
          "
          sortable
        ></el-table-column>
        <el-table-column
          prop="IdNo"
          label="身分證字號/護照號碼"
          :width="
            tableData.FeedBacks &&
            tableData.FeedBacks.length > 0 &&
            tableData.DynamicQuestionHeader.length > 0
              ? 120
              : null
          "
          sortable
        ></el-table-column>
        <el-table-column
          prop="ManpowerDemandName"
          label="應徵職務"
          :width="
            tableData.FeedBacks &&
            tableData.FeedBacks.length > 0 &&
            tableData.DynamicQuestionHeader.length > 0
              ? 120
              : null
          "
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="ContactPersonName"
          label="招募窗口"
          :width="
            tableData.FeedBacks &&
            tableData.FeedBacks.length > 0 &&
            tableData.DynamicQuestionHeader.length > 0
              ? 120
              : null
          "
        ></el-table-column>
        <el-table-column
          prop="ReplyContents"
          label="人事處理回饋"
          :width="
            tableData.FeedBacks &&
            tableData.FeedBacks.length > 0 &&
            tableData.DynamicQuestionHeader.length > 0
              ? 120
              : null
          "
        ></el-table-column>
        <el-table-column
          :key="index"
          width="90"
          :label="DynamicQuestionHeader"
          v-for="(
            DynamicQuestionHeader, index
          ) in tableData.DynamicQuestionHeader"
        >
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              :content="DynamicQuestionHeader"
              placement="bottom"
            >
              <div
                style="
                  text-overflow: ellipsis;
                  overflow: hidden;
                  width: 90px;
                  white-space: nowrap;
                "
              >
                {{ DynamicQuestionHeader }}
              </div>
            </el-tooltip>
          </template>
          <template slot-scope="props">
            <div
              :key="rowQuestion.Title"
              v-for="rowQuestion in props.row.Questions"
            >
              <div v-if="rowQuestion.Title === DynamicQuestionHeader">
                <span v-if="rowQuestion.Value === 'true'">是</span>
                <span
                  v-else-if="rowQuestion.Value === 'false'"
                  style="color: #ff0000"
                  >否</span
                >
                <span v-else>{{ rowQuestion.Value }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "RoomScheduleSetting",

  components: {},
  data() {
    return {
      reloadTime: null, //重新刷新的時間

      contactList: [],

      search: {
        RangeDate: [new Date(), new Date()],
      },
      tableData: [],

      person: {
        textarea: null,
      },

      timePeriodOptions: [],

      startPickerOptions: {
        disabledDate: null,
      },
      endPickerOptions: {
        disabledDate: null,
      },
    };
  },
  watch: {
    "search.InvitationStartTime": function () {
      const startDate = this.search.InvitationStartTime;
      let days = this.dayjs(this.search.InvitationStartTime);

      if (startDate) {
        this.endPickerOptions = {
          disabledDate(date) {
            return date < days;
          },
        };
      }
    },
    "search.InvitationEndTime": function () {
      const endDate = this.search.InvitationEndTime;
      let days = this.dayjs(this.search.InvitationEndTime);

      if (endDate) {
        this.startPickerOptions = {
          disabledDate(date) {
            return date > days;
          },
        };
      }
    },
  },

  methods: {
    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    //取得時段
    getTimePeriodOptions() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getTimePeriodOptions()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.timePeriodOptions = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    getData() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        ...vm.search,
        InvitationStartTime: vm.search.RangeDate
          ? vm.search.RangeDate[0]
          : null,
        InvitationEndTime: vm.search.RangeDate ? vm.search.RangeDate[1] : null,
      };

      vm.$api.InterviewSch.getFeedbackReport(params).then((response) => {
        if (response.data.ErrorMessage) {
          this.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          vm.tableData = response.data.Data;
        }
        vm.$store.dispatch("updateLoading", false);
      });
    },
    getFeedbackReportContact() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getFeedbackReportContact(vm.search).then(
        (response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.contactList = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        }
      );
    },

    exportExcel() {
      const vm = this;
      let params = {
        ...vm.search,
        InvitationStartTime: vm.search.RangeDate
          ? vm.search.RangeDate[0]
          : null,
        InvitationEndTime: vm.search.RangeDate ? vm.search.RangeDate[1] : null,
      };
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.exportFeedbackExcel(params).then((response) => {
        if (response.data.ErrorMessage) {
          this.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          let filename = decodeURIComponent(
            decodeURIComponent(
              response.headers["content-disposition"].split(
                "filename*=UTF-8''"
              )[1]
            )
          );

          let blob = new Blob([response.data]);
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = url;
          link.download = filename;
          link.click();

          window.URL.revokeObjectURL(url);
        }
        vm.$store.dispatch("updateLoading", false);
      });
    },

    dateFormatter(row, column) {
      if (row[column.property]) {
        return this.dayjs(row[column.property]).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },

    reload() {
      this.getTimePeriodOptions();
      this.getFeedbackReportContact();
      this.getData();
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  filters: {
    moment: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },
  },

  created() {
    this.getTimePeriodOptions();
    this.getFeedbackReportContact();
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.name-link {
  background-color: #d9e3ff;
  padding: 3px 15px;
  border-radius: 25px;
  display: inline-block;
  cursor: pointer;
  &.female {
    background-color: #ffd4d4;
  }
}
.p-card {
  background-color: #fff;
  overflow: hidden;
  border-radius: 6px;

  margin: 10px;
  .person-info {
    display: flex;
    padding: 20px;
    position: relative;
    z-index: 2;
    margin-bottom: -20px;
    img {
      width: 100px;
      height: 100px;
      object-fit: cover;
      border-radius: 10px;
      box-shadow: 5px 5px 0 rgba(#000, 0.15);
      margin-right: 15px;
    }
    .info {
      flex: 1;
      .name {
        font-size: 1.5em;
        font-weight: bold;
        margin-bottom: 5px;
      }
      .id {
        font-size: 0.8em;
      }
      .job {
        background-color: #5380f7;
        color: #fff;
        padding: 3px 15px;
        font-size: 0.8em;
        margin-top: 17px;
        border-radius: 25px;
        display: inline-block;
      }
    }
  }
  .job-info {
    background-color: #d9e3ff;
    padding: 20px;
    position: relative;
    &::after {
      content: "";
      width: 200%;
      height: 100px;
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      background-color: #d9e3ff;
      transform: rotate(-7deg);
      transform-origin: top left;
    }
    label {
      background-color: #fff;
      border-radius: 25px;
      padding: 3px 5px;
      overflow: hidden;
      display: flex;
      align-items: center;
      .svg-wrap {
        background-color: #5380f7;
        margin-right: 5px;
        border-radius: 50%;
        padding: 5px;
        width: 30px;
        height: 30px;
        svg {
          width: 100%;
          height: 100%;
          fill: #fff;
          position: relative;
          top: -4px;
        }
      }
      position: relative;
      z-index: 2;
      /deep/ .el-input__inner {
        border: none !important;
      }
      span {
        line-height: 40px;
        margin-left: 10px;
      }
    }
  }
}
</style>
